import React, { FunctionComponent, useCallback, useState } from 'react'
import { IconButton, IconsType } from '../../../components/shared'
import { CommonVariableActionsProps } from './CommonVariableActions.model'
import styles from './CommonVariableActions.module.scss'

export const CommonVariableActions: FunctionComponent<CommonVariableActionsProps> = ({
  children,
  customActions,
  onCopyVariable,
  onCopyVariableText,
  onChangeVariableToText,
  onUpdateVariableFixedValue,
}) => {
  const [hintLabel, setHintLabel] = useState('')

  const getTestId = useCallback((actionIcon: IconsType) => {
    switch (actionIcon) {
      case 'infoCircle':
        return 'button-common_variable-drug_monograph-open'
      case 'reload':
        return 'button-common_variable-to_vmp-convert'
      case 'pills':
        return 'button-common_variable-to_bio_similar-switch'
      case 'trash':
        return 'button-common_variable-manual_prescription-delete'
      default:
        return 'button-common_variable-custom_action'
    }
  }, [])

  return (
    <div>
      {children}
      <div className={styles.container}>
        <div className="flex space-x-4">
          <IconButton
            onMouseDown={onCopyVariable}
            onMouseOver={() => setHintLabel('Copier la variable')}
            onMouseLeave={() => setHintLabel('')}
            icon="copy"
            size="micro"
            theme="primary"
            testId="button-common_variable-add"
          />
          <IconButton
            onMouseDown={onCopyVariableText}
            onMouseOver={() => setHintLabel('Copier le texte de la variable')}
            onMouseLeave={() => setHintLabel('')}
            icon="copyText"
            size="micro"
            theme="primary"
            testId="button-common_variable-text-copy"
          />
          {null !== onChangeVariableToText && (
            <IconButton
              onMouseDown={onChangeVariableToText}
              onMouseEnter={() => setHintLabel('Remplacer la variable par son texte')}
              onMouseLeave={() => setHintLabel('')}
              icon="text"
              size="micro"
              theme="primary"
              testId="button-common_variable-by_text-replace"
            />
          )}
          {onUpdateVariableFixedValue && (
            <IconButton
              onMouseDown={onUpdateVariableFixedValue}
              onMouseEnter={() => setHintLabel('Mettre à jour la variable')}
              onMouseLeave={() => setHintLabel('')}
              icon="arrowCircle"
              size="micro"
              theme="primary"
              testId="button-common_variable-update"
            />
          )}
          {customActions &&
            customActions.map(({ icon, hint, onClick }, index) => (
              <IconButton
                key={index}
                onMouseDown={onClick}
                onMouseEnter={() => setHintLabel(hint)}
                onMouseLeave={() => setHintLabel('')}
                icon={icon}
                size="micro"
                theme="primary"
                testId={getTestId(icon)}
              />
            ))}
        </div>
        <div className={styles.hint}>{hintLabel}</div>
      </div>
    </div>
  )
}
